export enum dashboardTypes {
  UPDATE_KPI = "UPDATE_KPI",
  UPDATE_LINE_CHART_RESILIATION = "UPDATE_LINE_CHART_RESILIATION",
  UPDATE_LINE_CHART_ABONNEMENT = "UPDATE_LINE_CHART_ABONNEMENT",
  UPDATE_TABLEAU_SECTEUR = "UPDATE_TABLEAU_SECTEUR",
  UPDATE_TABLEAU_GLOBAL = "UPDATE_TABLEAU_GLOBAL",
  UPDATE_TABLEAU_GLOBAL_RESILIE = "UPDATE_TABLEAU_GLOBAL_RESILIE",
  IS_LOADING_DASHBOARD = "IS_LOADING_DASHBOARD",
  IS_LOADING_LINE_CHART_RESILIATION = "IS_LOADING_LINE_CHART_RESILIATION",
  IS_LOADING_LINE_CHART_ABONNEMENT = "IS_LOADING_LINE_CHART_ABONNEMENT",
}

export default dashboardTypes;
